import React from 'react';
import { Image, Nav, Navbar, Row, Col } from 'react-bootstrap';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import { AppNavigation, MessageNotification, ConnectedPatientSearch, UserMenu } from '.';
import { ResourceImage } from '.';
import { PatientRequestViewModelFragment } from '../graphql';
import logo from '../images/logo_CareMetx.png';
import { AnyType } from '../interfaces';
import { navigateToHome, navigateToPatient } from '../redux';
import { FeatureGuard } from './multi-tenant/FeatureGuard';
import { CustomThemes } from '../utils/custom-themes';
import { getConfigurationDataKey } from '../utils';
import './SearchInputWithGql.css';

interface MainToolbarProps {
  navigateToHome: () => void;
  navigateToPatient: (id: string | number) => void;
}

export const MainToolbar = (props: MainToolbarProps) => {
  CustomThemes();
  return (
    <Row>
      <Col sm={2} style={{ paddingRight: 'unset' }}>
        <Navbar>
          <Navbar.Brand onClick={props.navigateToHome} className='pointer' style={{ marginLeft: '15px' }}>
            <ResourceImage
              contentKey={getConfigurationDataKey('header.logo')}
              className='cmx__logo-toolbar__image pointer'
            />
          </Navbar.Brand>
        </Navbar>
      </Col>
      <Col sm={10} style={{ paddingLeft: 'unset', paddingRight: 'unset' }}>
        <Navbar collapseOnSelect expand='xl' className='fs-2 px-2 text-uppercase cmx__hcp-nav align-items-center py-0'>
          <Navbar.Toggle aria-controls='responsive-navbar-nav' className='border-0' />
          <Navbar.Collapse className=''>
            <Nav className=''>{renderPatientSearch(props)}</Nav>
            <MessageNotification />
            <UserMenu />
          </Navbar.Collapse>
        </Navbar>
      </Col>
    </Row>
  );
};

const renderPatientSearch = ({ navigateToPatient }: MainToolbarProps) => {
  const patientSearchRef = React.createRef();

  const onPatientSelect = (patient: PatientRequestViewModelFragment) => {
    navigateToPatient(patient.patientId);
    (patientSearchRef.current as AnyType).clear();
  };

  return (
    <Form
      // Do nothing since the patient search handles state.
      // Form is needed since search is a final form field (used in other forms).
      onSubmit={() => undefined}
      render={() => (
        <div className='w-auto align-items-start'>
          <div className='cmx__patient-search'>
            <div className='cmx__patient-search__search-outlined-input'>
              <div className='search-border'>
                <ConnectedPatientSearch
                  asyncTypeaheadProps={{ ref: patientSearchRef }}
                  placeholder='Search Patient Last Name or DOB'
                  onPatientSelect={onPatientSelect}
                  npiInfoSearch=''
                />
              </div>
            </div>
          </div>
        </div>
      )}
    />
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  navigateToHome,
  navigateToPatient
};

export const ConnectedMainToolbar = connect(mapStateToProps, mapDispatchToProps)(MainToolbar);
